module.exports = __webpack_public_path__ + "static/media/carrefour.b3a7f6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/partners/carrefour.png
// module id = 255
// module chunks = 0